import { Link } from 'react-router';
import time from 'utils/time';
import { UploadHubListItem } from 'api/services/uploadFileService';
import { getFileBadge } from 'components/UploadHub/fileTypeBadges';

interface UploadHubItemProps {
  file: UploadHubListItem;
}

const UploadHubItem = (props: UploadHubItemProps) => {
  const { file } = props ?? {};
  const { id, url, fileName, contentType, createdAtUtc, addedByUserFullName, publicId } = file;
  const badge = getFileBadge({ contentType });

  return (
    <Link to={`/files/${publicId}`} className='content-item-link d-block my-2' key={`upload-hub-file-${id ?? url}`}>
      <li className='p-3 border rounded'>
        <div className='d-flex'>
          <span
            className={`paragraph-p6 font-weight-bold mr-3 upload-hub-file-icon ${badge.className} text-white text-center flex-centered justify-content-center`}
          >
            {badge.label}
          </span>
          <div>
            <h4 className='content-item-title mb-0'>{fileName}</h4>
            {createdAtUtc && (
              <p className='text-grey-description mt-1 mb-0 paragraph-p3'>
                Uploaded on {time(createdAtUtc).formatGeneralDate()}{' '}
                <span className='heading-date'>
                  <span className='dot' />
                </span>{' '}
                {addedByUserFullName}
              </p>
            )}
          </div>
        </div>
      </li>
    </Link>
  );
};

export default UploadHubItem;
